import { render, staticRenderFns } from "./voter_list_admin.vue?vue&type=template&id=678a344a&scoped=true&"
import script from "./voter_list_admin.vue?vue&type=script&lang=js&"
export * from "./voter_list_admin.vue?vue&type=script&lang=js&"
import style0 from "./voter_list_admin.vue?vue&type=style&index=0&id=678a344a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678a344a",
  null
  
)

export default component.exports